/* Demo Sources page — displays a list of mock content sources. */

import { Badge } from "@/components/ui/badge";
import type { DemoSource } from "./demoData";
import { DEMO_SOURCES } from "./demoData";

interface DemoSourcesPageProps {
  sources?: DemoSource[];
}

export function DemoSourcesPage({ sources }: DemoSourcesPageProps) {
  const activeSources = sources ?? DEMO_SOURCES;

  return (
    <>
      <div className="sticky top-0 z-20 bg-background">
        <div className="flex items-center gap-3 px-4 md:px-6 pt-4 pb-2">
          <h1 className="text-lg font-bold text-heading-foreground">Sources</h1>
          <Badge variant="secondary" className="text-xs">
            {activeSources.length}
          </Badge>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 md:px-6 pt-2">
        {activeSources.map((source, i) => (
          <div key={source.name}>
            <div className="flex items-center gap-3 py-3">
              <div
                className="size-9 rounded-full shrink-0 flex items-center justify-center text-white text-xs font-bold"
                style={{ backgroundColor: source.iconColor }}
              >
                {source.name.charAt(0)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-heading-foreground truncate">
                  {source.name}
                </p>
                <p className="text-xs text-muted-foreground">
                  {source.itemCount} items
                </p>
              </div>
              <Badge variant="outline" className="text-xs capitalize">
                {source.contentType}
              </Badge>
            </div>
            {i < activeSources.length - 1 && (
              <div className="border-b border-border/50" />
            )}
          </div>
        ))}
      </div>
    </>
  );
}
